import { readReturnTo } from "../blocks/layout/recordLinkState";
import { getListDefinition } from "../lists/listDefinitions";
import { listReturnPath } from "../lists/listReturnPath";
import { RecordDefinition } from "./recordDefinition.types";
import { getRecordDefinitionByPath } from "./recordDefinitions";

/** What a record page's Back and close go to, and what the Back button says. */
export interface ReturnTarget {
  path: string;
  title: string;
}

// Named after the page being returned to, the way each definition's backTitle reads.
function titleFor(returnTo: string) {
  const pathname = returnTo.split("?")[0];
  const list = getListDefinition(pathname);

  if (list) {
    return `Back to ${list.title.toLowerCase()}`;
  }

  const page = getRecordDefinitionByPath(pathname.replace(/^\//, ""));

  return page ? `Back to ${page.identity.fallbackTitle.toLowerCase()}` : "Back";
}

/**
 * The page a record link was pressed on, when there was one; otherwise the record's own
 * list at the search it was left at.
 */
export function getReturnTarget(
  definition: RecordDefinition | undefined,
  routerState: unknown
): ReturnTarget | undefined {
  const returnTo = readReturnTo(routerState);

  if (returnTo) {
    return { path: returnTo, title: titleFor(returnTo) };
  }

  return definition?.listRoute
    ? {
        path: listReturnPath(definition.listRoute),
        title: definition.backTitle ?? "Back",
      }
    : undefined;
}
